import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, CardContent, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useRetrieveUserLeaguePermissions } from "../api/PermissionApiProvider";
import { useRetrieveSeason, useUpdateSeason } from "../api/SeasonApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { NotFound } from "../nav/NotFound";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
import { SeasonForm } from "./SeasonForm";
export const UpdateSeason = () => {
    const { leagueId, id } = useNumericParams();
    const navigate = useNavigate();
    const { data: permissions, isLoading: permissionsLoading, error: permissionsError, } = useRetrieveUserLeaguePermissions({ leagueId });
    const { canModify = false } = permissions || {};
    const { data: season, isLoading, error, } = useRetrieveSeason({ id, enabled: canModify });
    const mutation = useUpdateSeason({
        onMutate: () => { },
        onSuccess: (data) => {
            const updated = data.data;
            navigate(`/leagues/${leagueId}/seasons/${updated.id}`);
        },
        onError: () => { },
    });
    if (permissionsLoading) {
        return _jsx(Loading, {});
    }
    if (permissionsError) {
        return _jsx(ErrorView, { error: permissionsError });
    }
    if (!canModify) {
        return _jsx(NotFound, {});
    }
    if (isLoading) {
        return _jsx(Loading, {});
    }
    if (error || !season) {
        return _jsx(ErrorView, { error: error || new Error("Failed to load season") });
    }
    const handleSubmit = (form) => {
        mutation.mutate({ ...season, ...form, id: season.id });
    };
    return (_jsx(Card, { children: _jsxs(CardContent, { children: [_jsx(ErrorSnackbar, { open: mutation.isError, message: "Failed to update season. Please try again.", onClose: () => { } }), _jsx(Typography, { variant: "h6", gutterBottom: true, children: "Update Season" }), _jsx(SeasonForm, { onSubmit: handleSubmit, season: season })] }) }));
};
